export default __webpack_public_path__ + "static/media/right-leafs.561b88e8.svg";